export default {"src":"/static/spa/fresh-spa/_next/static/media/icon-experts.165db06d.svg","height":67,"width":68,"blurWidth":0,"blurHeight":0};